import { render, staticRenderFns } from "./Terms.vue?vue&type=template&id=20cfb9fd&scoped=true"
import script from "./Terms.vue?vue&type=script&lang=js"
export * from "./Terms.vue?vue&type=script&lang=js"
import style0 from "./Terms.vue?vue&type=style&index=0&id=20cfb9fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.npm/_npx/14f5bcddd9f17f34/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cfb9fd",
  null
  
)

export default component.exports